export const REDIRECT_URI = "http://akademi.al";

export const SUPPORT_EMAIL = "support@akademi.al";

export const HOW_TO_ADD_ASSIGNMENT_URI = "https://akademial.tawk.help/article/si-t%C3%AB-jap-detyrat-e-sht%C3%ABpis%C3%AB-p%C3%ABr-nx%C3%ABn%C3%ABsit-e-mi";